import { restApi } from '../../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { paginate } from '../../../lib/loopback'

const analistaCentroCustoRepository = createRepository({
  path: 'analista-centrosCusto',
  parentPath: 'centrosCusto',
  relationType: 'path',
  restApi,
  queryTransform: {
    ...paginate
  }
})

analistaCentroCustoRepository.remove = async ({ id }) => {
  if (!id) throw new Error('ID é obrigatório para delete')
  const uri = `analista-centrosCusto/${id}`
  const response = await restApi.delete(uri)
  return {
    ok: response.ok,
    data: response.data
  }
}

analistaCentroCustoRepository.getOne = ({ id }) => {
  return restApi.get(`analista-centrosCusto/${id}`)
}

export default analistaCentroCustoRepository
